<div class="form-group">
  <label [for]="name" *ngIf="label">{{placeholder | titlecase}}</label>
  <div class="input-group">
    <div class="input-group-prepend">
      <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button"><i
          class="bi bi-calendar"></i></button>
    </div>
    <input class="form-control" placeholder="dd/mm/yyyy" [name]="name" [(ngModel)]="modelDateStruct" ngbDatepicker
      #d="ngbDatepicker" (ngModelChange)="eventChange()" #errorModel="ngModel" [required]="required">
  </div>
  <span class="text-danger" *ngIf="(model || (myForm && myForm.submitted)) && errorModel.errors?.required">
    Il campo {{placeholder}} è obbligatorio
  </span>
</div>